class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosurePicker extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.addEventListener('keyup', onKeyUpEscape);
  }

  onToggle() {
    if (!this.mainDetailsToggle.open) {
      document.removeEventListener('click', this.handleClickOutside);
      return;
    }

    // Use a timeout to allow the 'click' event that opened the details to pass
    setTimeout(() => {
      document.addEventListener('click', this.handleClickOutside, { once: true });
    });
  }

  handleClickOutside = (event) => {
    if (this.mainDetailsToggle.open && !this.contains(event.target)) {
      this.close();
    } else if (this.mainDetailsToggle.open) {
      // If the click was inside, we need to re-attach the listener
      document.addEventListener('click', this.handleClickOutside, { once: true });
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure-picker', DetailsDisclosurePicker);
